import { jsx as _jsx } from "react/jsx-runtime";
import { FadeIn, FadeOut } from "react-native-reanimated";
import { Box } from "@kolmeo/ui-core";
import { createAnimatedComponent } from "./helpers";
const AnimatedBox = createAnimatedComponent(Box);
const FadeAnimation = ({ children, enterDuration = 200, enterDelay = 0, exitDelay = 0, isExit = true, exitDuration = 200, ...props }) => {
    return (_jsx(AnimatedBox, { entering: FadeIn.duration(enterDuration).delay(enterDelay), exiting: isExit ? FadeOut.duration(exitDuration).delay(exitDelay) : undefined, ...props, children: children }));
};
export default FadeAnimation;
